import {
  createRootRoute,
  createRoute,
  createRouter,
} from '@tanstack/react-router';

import { RequestAccessPage } from './auth/RequestAccessPage';
import LeaveRequestPage from './LeaveRequestPage';
import { Home, PermissionsPage, Root, ToolPage } from './Shell';

/**
 * The routes (`admin-is-an-app` D3): each tool at `/<id>` with everything under it, built
 * from the manifests rather than from files, so a tool adds no route here — and the four
 * the shell owns for its own surfaces, Home, User Permissions, the leave form and Request
 * Access (`permissions-is-in-the-profile` D1, D3; `leave-request-is-an-embed` D1;
 * `request-access-is-a-page` D2). A static segment outranks `$tool`, so the shell's own
 * routes need no ordering against it.
 *
 * `/admin-access` is the one of the four a session does not have to be staff to open, and
 * `Root` answers it before either refusal — so this route is reached only by a staff member
 * who followed the link anyway, and the page tells them they already have what it asks for.
 */
const root = createRootRoute({ component: Root });
const home = createRoute({
  getParentRoute: () => root,
  path: '/',
  component: Home,
});
const permissions = createRoute({
  getParentRoute: () => root,
  path: 'permissions',
  component: PermissionsPage,
});
const leaveRequest = createRoute({
  getParentRoute: () => root,
  path: 'leave-request',
  component: LeaveRequestPage,
});
const adminAccess = createRoute({
  getParentRoute: () => root,
  path: 'admin-access',
  component: RequestAccessPage,
});
const tool = createRoute({
  getParentRoute: () => root,
  path: '$tool',
  component: ToolPage,
});
const toolPath = createRoute({
  getParentRoute: () => root,
  path: '$tool/$',
  component: ToolPage,
});

export const routeTree = root.addChildren([
  home,
  permissions,
  leaveRequest,
  adminAccess,
  tool,
  toolPath,
]);

export function makeRouter() {
  return createRouter({ routeTree, defaultPreload: false });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof makeRouter>;
  }
}
